var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import ReportValue from "../../../../../../../shared-library/components/commonTableVal";
import { addCommas, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
var InterestTable = function (props) {
    var _a = __read(React.useState([false]), 2), openAcc = _a[0], setOpenAcc = _a[1];
    var _b = __read(React.useState(0), 2), total = _b[0], setTotal = _b[1];
    React.useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.dpcData) && (props === null || props === void 0 ? void 0 : props.dpcData.length) > 0) {
            var sum_1 = 0;
            props === null || props === void 0 ? void 0 : props.dpcData.map(function (dpc, idx) {
                sum_1 = sum_1 + Number(dpc.amount);
            });
            setTotal(sum_1);
        }
    }, [props === null || props === void 0 ? void 0 : props.dpcData]);
    //     month: "February - 2018",
    //     amount: "10460.62",
    //     details: [
    //       {
    //         t_date: "21 Feb 2018",
    //         amount: "39,457.64",
    //         days: "30",
    //         interest_rate: "5",
    //         interest_amount: "6047.52",
    //       },
    //       {
    //         t_date: "21 Feb 2018",
    //         amount: "39,457.64",
    //         days: "30",
    //         interest_rate: "5",
    //         interest_amount: "6047.52",
    //       },
    //     ],
    //   },
    //   {
    //     month: "February - 2018",
    //     amount: "10460.62",
    //     details: [
    //       {
    //         t_date: "21 Feb 2018",
    //         amount: "39,457.64",
    //         days: "30",
    //         interest_rate: "5",
    //         interest_amount: "6047.52",
    //       },
    //       {
    //         t_date: "21 Feb 2018",
    //         amount: "39,457.64",
    //         days: "30",
    //         interest_rate: "5",
    //         interest_amount: "6047.52",
    //       },
    //     ],
    //   },
    // ];
    return (React.createElement(React.Fragment, null,
        (props === null || props === void 0 ? void 0 : props.dpcData) &&
            (props === null || props === void 0 ? void 0 : props.dpcData.length) > 0 &&
            (props === null || props === void 0 ? void 0 : props.dpcData.map(function (dpc, idx) {
                return (React.createElement("div", { key: idx, className: "charges-table ".concat(openAcc[idx] ? "openAccmain" : "") },
                    React.createElement("div", { className: "table common-table " },
                        React.createElement("div", { className: "profile-main-tablebody-tr  d-flex align-items-center justify-content-between py-3 px-2 ".concat(openAcc[idx] ? "openAcc" : "") },
                            React.createElement("div", null,
                                React.createElement("span", { className: "hand_cursor" },
                                    React.createElement("i", { className: openAcc[idx]
                                            ? "edel-icon-arrow-up"
                                            : "edel-icon-arrow-down", onClick: function () {
                                            var temp = __spreadArray([], __read(openAcc), false);
                                            temp[idx] = !temp[idx];
                                            setOpenAcc(temp);
                                        } })),
                                React.createElement("span", { className: "arrowicon-td DMSan_14_500" }, dpc.month)),
                            React.createElement("div", null,
                                React.createElement(ReportValue, { stream: false, onlyval: false, val: dpc.amount, parentClass: "RobotoM_14_500" }))),
                        openAcc[idx] && (React.createElement("table", null,
                            React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                                React.createElement("td", null, "Transaction Date"),
                                React.createElement("td", null, "Running Amount (Rs)"),
                                React.createElement("td", null, "Days"),
                                React.createElement("td", null, "Interest Rate (%)"),
                                React.createElement("td", null, "Interest Amount (Rs)")),
                            React.createElement("tbody", null, dpc.dpC_ChargeDetails &&
                                dpc.dpC_ChargeDetails.length > 0 &&
                                dpc.dpC_ChargeDetails.map(function (subList, idx) {
                                    return (React.createElement("tr", { key: idx, className: "DMSanM_14_500 txt_blackOne1" },
                                        React.createElement("td", null, subList.transactionDate),
                                        React.createElement("td", null,
                                            React.createElement(ReportValue, { stream: false, onlyval: false, val: subList.runAmount, parentClass: "RobotoM_14_500" })),
                                        React.createElement("td", null, subList.days),
                                        React.createElement("td", null, subList.interest),
                                        React.createElement("td", null,
                                            React.createElement(ReportValue, { stream: false, onlyval: false, val: subList.interestAmt, parentClass: "RobotoM_14_500" }))));
                                })))))));
            })),
        (props === null || props === void 0 ? void 0 : props.dpcData) && (props === null || props === void 0 ? void 0 : props.dpcData.length) > 0 && total && (React.createElement("div", { className: "charges-table d-flex justify-content-between" },
            React.createElement("span", { className: "DMSan_14_500" }, "Total"),
            React.createElement("span", { className: "RobotoM_14_500 me-3" }, addCommas(roundUpToTwoDecimalPlaces(total)))))));
};
export default InterestTable;
